export const DISPLAY_AFFILIATE_FINDER = 'DISPLAY_AFFILIATE_FINDER';
export const DISPLAY_AI_MESSAGE_CENTER = 'DISPLAY_AI_MESSAGE_CENTER';
export const DISPLAY_CRM = 'DISPLAY_CRM';
export const SHOW_TIKTOK_FULL = 'SHOW_TIKTOK_FULL';
export const SHOW_VIDEO_AI = 'SHOW_VIDEO_AI';
export const SHOW_DASHBOARD = 'SHOW_DASHBOARD';
export const SHOW_YOUTUBE_CAMPAIGN_SETUP = 'SHOW_YOUTUBE_CAMPAIGN_SETUP';
export const SHOW_DRAFT_DATA_TAB = 'SHOW_DRAFT_DATA_TAB';
